<ng-container *ngIf="isLoading">
    <div class="d-flex justify-content-center align-items-center loader-overlay">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</ng-container>
